import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function PmiOverviewImage({ style }) {
  return (
    <StaticQuery
      query={graphql`
        query {
          file(relativePath: { eq: "horticulture/pmi-overview.png" }) {
            childImageSharp {
              fluid(maxHeight: 450) {
                ...GatsbyImageSharpFluid
              }
              fixed(width: 915) {
                src
              }
            }
          }
        }
      `}
      render={(data) => (
        <a href={data.file.childImageSharp.fixed.src}>
          <Img style={{ ...style }} fluid={data.file.childImageSharp.fluid} />
        </a>
      )}
    />
  );
}
